import { render, staticRenderFns } from "./RLP.vue?vue&type=template&id=0527ed12&scoped=true"
import script from "./RLP.vue?vue&type=script&lang=js"
export * from "./RLP.vue?vue&type=script&lang=js"
import style0 from "./RLP.vue?vue&type=style&index=0&id=0527ed12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0527ed12",
  null
  
)

export default component.exports